import React, { useState } from 'react';
import '../../../css/Turismo/lugares-ciudad.css';
import ReferenciasGenerales from './Lugares/ReferenciasGenerales';
import EstacionesServicio from './Lugares/EstacionesServicio';
import IglesiasEvangelicas from './Lugares/IglesiasEvangelicas';
import Hospedajes from './Lugares/Hospedajes';
import Servicios from './Lugares/Servicios';
import Farmacias from './Lugares/Farmacias';
import Gastronomia from './Lugares/Gastronomia';
import SalonesFiestas from './Lugares/SalonesFiestas';
import AgenciasViajes from './Lugares/AgenciasViajes';
import TerminalOmnibus from './Lugares/TerminalOmnibus';
import Chacinados from './Lugares/Chacinados';
import Lacteos from './Lugares/Lacteos';
import Deporte from './Lugares/Deporte';

const tabs = [
  { id: "generales", label: "Referencias Generales" },
  { id: "estacion", label: "Estaciones de Servicio" },
  { id: "iglesias", label: "Iglesias Evangelicas" },
  { id: "hospedajes", label: "Hospedajes" },
  { id: "servicios", label: "Servicios" },
  { id: "farmacias", label: "Farmacias" },
  { id: "gastronomia", label: "Gastronomía" },
  { id: "salones", label: "Salones de Fiestas" },
  { id: "agencias", label: "Agencias de viajes" },
  { id: "terminal", label: "Terminal de Ómnibus" },
  { id: "chacinados", label: "Chacinados" },
  { id: "lacteos", label: "Lacteos" },
  { id: "deporte", label: "Deporte" },
];

const LugaresCiudad = () => {
  const [activeTab, setActiveTab] = useState("generales");

  return (
    <section className="referencia-mapa" id="lugares-de-la-ciudad">
      <h3><strong>Lugares</strong> de la ciudad</h3>
      <div className="row contPrincipal">
        <div className="col-12 col-md-8">
          {/* Menú desplegable solo visible en móviles */}
          <div className="tabs-mobile-select d-md-none mb-3">
            <label htmlFor="lugares-mobile-select">Seleccioná una sección:</label>
            <select
              id="lugares-mobile-select"
              className="form-select"
              value={activeTab}
              onChange={e => setActiveTab(e.target.value)}
            >
              {tabs.map(tab => (
                <option key={tab.id} value={tab.id}>{tab.label}</option>
              ))}
            </select>
          </div>
          {/* Tabs visibles solo en desktop */}
          <ul className="nav nav-tabs justify-content-center pestaña d-none d-md-flex" role="tablist">
            {tabs.map(tab => (
              <li className="nav-item" key={tab.id} role="presentation">
                <button
                  className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                  id={`${tab.id}-tab`}
                  type="button"
                  role="tab"
                  aria-controls={tab.id}
                  aria-selected={activeTab === tab.id}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>
          <div className="tab-content mt-4">
            <div className="tab-pane fade show active">
              <div>
                {activeTab === "generales" && <div className='contGeneral'><ReferenciasGenerales /></div>}
                {activeTab === "estacion" && <div className='contGeneral'><EstacionesServicio /></div>}
                {activeTab === "iglesias" && <div className='contGeneral'><IglesiasEvangelicas /></div>}
                {activeTab === "hospedajes" && <div className='contGeneral'><Hospedajes /></div>}
                {activeTab === "servicios" && <div className='contGeneral'><Servicios/></div>}
                {activeTab === "farmacias" && <div className='contGeneral'><Farmacias /></div>}
                {activeTab === "gastronomia" && <div className='contGeneral'><Gastronomia /></div>}
                {activeTab === "salones" && <div className='contGeneral'><SalonesFiestas/></div>}
                {activeTab === "agencias" && <div className='contGeneral'><AgenciasViajes/></div>}
                {activeTab === "terminal" && <div className='contGeneral'><TerminalOmnibus/></div>}
                {activeTab === "chacinados" && <div className='contGeneral'><Chacinados/></div>}
                {activeTab === "lacteos" && <div className='contGeneral'><Lacteos/></div>}
                {activeTab === "deporte" && <div className='contGeneral'><Deporte/></div>}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bloque de tarjetas fijo después de la lista de lugares */}
      <div className="row mt-3 contenedor-tarjetas">
        <div className="col-12 col-md-6 col-lg-3">
          <div className="card-referencias">
            <div className="img-referencias">
              <img src={require("../../img/Oficina-de-Turismo.jpg")} alt="Oficina de Turismo" />
              <div className="overlay"></div>
              <div className="text-container">
                <h2 style={{ fontSize: 20 }}>Oficina de Turismo</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <div className="card-referencias">
            <div className="img-referencias">
              <img src={require("../../img/Terminal01.jpeg")} alt="Terminal de Ómnibus" />
              <div className="overlay"></div>
              <div className="text-container">
                <h2 style={{ fontSize: 20 }}>Terminal de Ómnibus</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <div className="card-referencias">
            <div className="img-referencias">
              <img src={require("../../img/Mural-Ferrocarril-01.jpeg")} alt="Mural Ferrocarril" />
              <div className="overlay"></div>
              <div className="text-container">
                <h2 style={{ fontSize: 20 }}>Mural Ferrocarril</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <div className="card-referencias">
            <div className="img-referencias">
              <img src={require("../../img/Museo-1.jpg")} alt="Museo Nacional de Malvinas" />
              <div className="overlay"></div>
              <div className="text-container">
                <h2 style={{ fontSize: 20 }}>Museo Nacional de Malvinas</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Fin bloque tarjetas */}

      <br />
      <div className="boton-mapa">
        <a href="https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/mapa-turistico-de-la-ciudad-de-oliva.pdf" target="_blank" rel="noopener noreferrer">
          <i className="fa-solid fa-file-arrow-down"></i> Descargar guía turistica de la ciudad de Oliva
        </a>
      </div>
    </section>
  );
};

export default LugaresCiudad;